import { AppCore } from "../../api/core/AppCore";
import { CurrencyUtil } from "../../util/currency/CurrencyUtil";
import { Delay } from "../../util/time/Delay";
/**
 * AbstractController.ts
 *
 * Base class for all controllers.
 *
 * It is persistent, cannot be completely killed.
 *
 * `destroy()` calls `sleep()` calls `removeEventListeners()`.
 *
 * `run()` calls `create()`, `postCreate()`, and `addEventListeners()`.
 */
export class AbstractController {
    constructor() {
        this.core = AppCore.getInstance();
    }
    create() {
        this.createModel();
    }
    postCreate() { }
    createModel() { }
    destroy() {
        this.sleep();
    }
    /**
     * Any additions to addEventListeners() must also be added to removeEventListeners().
     */
    addEventListeners() { }
    removeEventListeners() { }
    /**
     * Register an event listener with the `core` event bus.
     * Only one function can be bound to an event per controller.
     *
     * Call `unregisterCore(type)` to remove the listener.
     */
    registerCore(type, handler) {
        this.core.addEventListener(type.getType(), handler, this);
    }
    /**
     * Unregister an event listener from the `core` event bus.
     */
    unregisterCore(type) {
        this.core.removeEventListener(type.getType(), this);
    }
    /**
     * Dispatch an event to the `core` event bus.
     *
     * @param event - The event to dispatch.
     * @param delay - Optional delay in milliseconds before dispatching the event.
     */
    dispatchCore(event, delay = 0) {
        if (delay > 0) {
            Delay.create(delay, this.core.dispatchEvent, this.core, event);
        }
        else {
            this.core.dispatchEvent(event);
        }
    }
    /**
     * @returns new `Delay` instance
     * @param delay - Time in milliseconds
     * @param handler - Function to be called
     * @param args - Agurments to be passed to `handler`
     */
    callAfter(delay, handler, args) {
        return Delay.create(delay, handler, this, args);
    }
    formatCurrency(value) {
        return CurrencyUtil.format(value);
    }
    run() {
        if (!this.running) {
            this.running = true;
            this.create();
            this.postCreate();
            this.addEventListeners();
        }
    }
    sleep() {
        if (this.running) {
            this.running = false;
            this.removeEventListeners();
        }
    }
}
//# sourceMappingURL=AbstractController.js.map